import styled from 'styled-components';

import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const Rank = styled.span`
  display: inline-block;
  text-align: center;
  background-color: #000;
  color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 24px;
  height: 24px;
  line-height: 24px;
  font-size: 13px;

  @media ${({ theme }) => theme.media.smMax} {
    width: ${mixin.pxToVw('24')};
    height: ${mixin.pxToVw('24')};
    line-height: ${mixin.pxToVw('24')};
    font-size: ${mixin.pxToVw('13')};
  }

  @media ${({ theme }) => theme.media.pc} {
    width: 28px;
    height: 28px;
    line-height: 28px;
    font-size: 15px;
  }
`;

export const Img = styled.div`
  position: relative;

  .img {
    padding-bottom: 133.1550802139037%;

    &:after {
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0px;
      left: 0px;
      background-color: rgba(0, 0, 0, 0.03);
    }
  }

  .emblem-area {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 70px;
    background: linear-gradient(
      to bottom left,
      rgba(0, 0, 0, 0.15) 0%,
      rgba(0, 0, 0, 0) 55%
    );

    svg {
      position: absolute;
      width: 44px;
      height: auto;
      top: 10px;
      right: 9px;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    .emblem-area {
      height: ${mixin.pxToVw('70')};

      svg {
        width: ${mixin.pxToVw('44')};
        top: ${mixin.pxToVw('10')};
        right: ${mixin.pxToVw('9')};
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    .img {
      padding-bottom: 133.495145631068%;
    }

    .emblem-area {
      height: 90px;

      svg {
        width: 52px;
        top: 12px;
        right: 11px;
      }
    }
  }
`;

export const Title = styled.span`
  display: block;

  .title,
  .front,
  .detail {
    display: block;
    margin-top: 2px;
    font-size: 13px;
    line-height: 130%;
    color: #333;
    ${mixin.ellipsis(1)};
  }

  .title {
    color: #000;
    padding-right: 23px;
    font-weight: 600;
  }

  .detail {
    ${mixin.ellipsis(2)};
  }

  @media ${({ theme }) => theme.media.smMax} {
    .title,
    .front,
    .detail {
      margin-top: ${mixin.pxToVw('2')};
      font-size: ${mixin.pxToVw('13')};
    }

    .title {
      padding-right: ${mixin.pxToVw('23')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    .title {
      margin-top: 1px;
      font-size: 15px;
    }

    .front,
    .detail {
      margin-top: 4px;
      font-size: 14px;
    }
  }
`;

export const Price = styled.span`
  ${mixin.flex({ justify: 'flex-start', wrap: 'wrap' })};
  margin-top: 6px;

  .customer-price {
    color: #acacac;
    text-decoration: line-through;
    font-size: 11px;
    line-height: 130%;
    width: 100%;
  }

  .final-discount {
    color: #ff4600;
    line-height: 130%;
    font-size: 14px;
    margin-right: 6px;

    em {
      font-weight: 600;
    }
  }

  .final-price {
    color: #000;
    font-size: 14px;
    line-height: 130%;

    strong {
      font-weight: 600;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    margin-top: ${mixin.pxToVw('6')};

    .customer-price {
      font-size: ${mixin.pxToVw('11')};
    }

    .final-discount {
      font-size: ${mixin.pxToVw('14')};
      margin-right: ${mixin.pxToVw('6')};
    }

    .final-price {
      font-size: ${mixin.pxToVw('14')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    margin-top: 8px;

    .customer-price {
      font-size: 12px;
    }

    .final-discount {
      font-size: 17px;
      margin-right: 7px;
    }

    .final-price {
      font-size: 17px;
    }
  }
`;

export const Stats = styled.span`
  ${mixin.flex({ justify: 'flex-start' })};
  margin-top: 6px;

  .review,
  .like {
    ${mixin.flex({ justify: 'flex-start' })}
    margin-left: 10px;

    &:first-child {
      margin-left: 0;
    }

    svg {
      width: 10px;
      height: 10px;
    }

    .cnt {
      color: #999;
      font-size: 12px;
      line-height: 130%;
    }
  }

  .review {
    .score {
      margin-left: 2px;
    }

    .cnt {
      margin-left: 2px;
    }

    .score {
      color: #999;
      font-size: 12px;
      line-height: 130%;
    }
  }

  .like {
    svg {
      margin-top: 1px;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    margin-top: ${mixin.pxToVw('6')};

    .review,
    .like {
      margin-left: ${mixin.pxToVw('10')};

      svg {
        width: ${mixin.pxToVw('10')};
        height: ${mixin.pxToVw('10')};
      }

      .cnt {
        font-size: ${mixin.pxToVw('12')};
      }
    }

    .review {
      .score {
        margin-left: ${mixin.pxToVw('2')};
      }

      .cnt {
        margin-left: ${mixin.pxToVw('2')};
      }

      .score {
        font-size: ${mixin.pxToVw('12')};
      }
    }

    .like {
      svg {
        margin-top: ${mixin.pxToVw('1')};
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    margin-top: 10px;
  }
`;

export const AreaTag = styled.span`
  display: block;
  margin-top: 10px;

  .tag {
    margin-left: 4px;

    &:first-child {
      margin-left: 0;
    }
    &.tag-soldout {
      background-color: #bbb;
      color: #fff;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    margin-top: ${mixin.pxToVw('10')};

    .tag {
      margin-left: ${mixin.pxToVw('4')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    margin-top: 10px;
  }
`;

export const AreaAdTag = styled.span`
  position: absolute;
  bottom: 0;
  right: 0;

  .tag {
    &.tag-ad {
      width: 28px;
      height: 18px;
      padding: 2px 4px;
      background: rgba(0, 0, 0, 0.4);
      color: #fff;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    .tag {
      &.tag-ad {
        width: ${mixin.pxToVw('28')};
        height: ${mixin.pxToVw('18')};
        padding: ${mixin.pxToVw('2 4')};
      }
    }
  }
`;

export const AreaInfo = styled.span`
  position: relative;
  display: block;
  text-align: left;

  .area-click {
    text-align: left;
    padding: 12px 12px 0 12px;
  }

  .tag-sale {
    background-color: #ff4600;
    color: #fff;
    line-height: 100%;
    position: absolute;
    font-size: 12px;
    padding: 5px 6px;
    top: -11px;
    left: 12px;
  }

  .like-pick {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 34px;
    height: 34px;
    z-index: 1;
  }

  .viewStyVd-btn {
    margin-top: 12px;
    margin-left: 12px;
  }

  @media ${({ theme }) => theme.media.smMax} {
    .area-click {
      padding: ${mixin.pxToVw('12 12 0 12')};
    }

    .tag-sale {
      font-size: ${mixin.pxToVw('12')};
      padding: ${mixin.pxToVw('5 6')};
      top: ${mixin.pxToVw('-11')};
      left: ${mixin.pxToVw('12')};
    }

    .like-pick {
      top: ${mixin.pxToVw('4')};
      right: ${mixin.pxToVw('4')};
      width: ${mixin.pxToVw('34')};
      height: ${mixin.pxToVw('34')};
    }

    .viewStyVd-btn {
      margin-top: ${mixin.pxToVw('12')};
      margin-left: ${mixin.pxToVw('12')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    .area-click {
      padding: 14px 0 0 0;
    }

    .tag-sale {
      left: 0px;
    }

    .like-pick {
      top: 14px;
      right: 0px;
      width: 20px;
      height: 20px;
    }

    .viewStyVd-btn {
      margin-top: 16px;
      margin-left: 0;
    }
  }
`;

export const AreaClick = styled(Button)`
  display: block;
  width: 100%;
  position: relative;
  z-index: 0;

  &.area-img {
    .veVideo {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      opacity: 0;
      visibility: hidden;
      background: none;
      transition: opacity 0.4s ease-in-out, visibility 0.4s ease-in-out;

      > div[id],
      .xgplayer {
        height: 100%;
      }

      .xgplayer {
        width: 101%;
        height: 101%;
        transform: translate(-0.5%, -0.5%);
      }

      .loading-icon {
        display: none !important;
      }
    }

    .play-icon {
      position: absolute;
      top: 8px;
      right: 8px;
      width: 22px;
      height: 22px;

      svg {
        width: 7px;
        height: 8px;
        margin-left: 9px;
      }
    }

    .veVideo.is-player-play {
      opacity: 1;
      visibility: visible;
    }

    .veVideo.is-player-play + .play-icon {
      opacity: 0;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    &.area-img {
      .play-icon {
        top: ${mixin.pxToVw('8')};
        right: ${mixin.pxToVw('8')};
        width: ${mixin.pxToVw('22')};
        height: ${mixin.pxToVw('22')};

        svg {
          width: ${mixin.pxToVw('7')};
          height: ${mixin.pxToVw('8')};
          margin-left: ${mixin.pxToVw('9')};
        }
      }
    }
  }
`;

export const ColorChips = styled.span`
  ${mixin.flex({ justify: 'flex-start' })};
  gap: 2px;
  padding-left: 12px;
  margin-top: 10px;

  .chip {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    flex-shrink: 0;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: inherit;
      border: 1px solid rgba(0, 0, 0, 0.15);
      pointer-events: none;
    }
  }

  .chip-more {
    font-size: 11px;
    color: #999;
    line-height: 130%;
    margin-left: 2px;
  }

  @media ${({ theme }) => theme.media.smMax} {
    gap: ${mixin.pxToVw('2')};
    padding-left: ${mixin.pxToVw('12')};
    margin-top: ${mixin.pxToVw('10')};

    .chip {
      width: ${mixin.pxToVw('12')};
      height: ${mixin.pxToVw('12')};
    }

    .chip-more {
      font-size: ${mixin.pxToVw('11')};
      margin-left: ${mixin.pxToVw('2')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    gap: 3px;
    padding-left: 0;
    margin-top: 14px;
    padding-bottom: 1px;

    .chip {
      width: 12px;
      height: 12px;
    }

    .chip-more {
      font-size: 12px;
      margin-left: 1px;
    }
  }
`;

export const PrdcUnitItem = styled.div`
  font-family: 'Pretendard Variable', Pretendard, -apple-system,
    BlinkMacSystemFont, 'Apple SD Gothic Neo', Roboto, 'Noto Sans KR',
    'Segoe UI', 'Malgun Gothic', 'Apple Color Emoji', 'Segoe UI Emoji',
    'Segoe UI Symbol', sans-serif;

  position: relative;
  overflow: hidden;

  &.type-simple {
    .area-info {
      .area-click {
        padding: 10px 4px 0 4px;

        .prdc-title {
          .detail {
            ${mixin.ellipsis(1)};
            padding-right: 23px;
          }

          .title + .detail {
            padding-right: 0;
          }
        }

        .prdc-price {
          margin-top: 2px;
        }

        .area-tag {
          margin-top: 8px;
        }
      }

      .like-pick {
        top: 2px;
        right: -4px;
      }
    }
  }

  &.type-simple-small {
    .img {
      padding-bottom: 132.7%;
    }

    .emblem-area {
      height: 50px;

      svg {
        width: 32px;
        top: 8px;
        right: 7px;
      }
    }

    .rank {
      width: 20px;
      height: 20px;
      line-height: 20px;
      font-size: 11px;
      font-weight: 500;
    }

    .area-info {
      .area-click {
        padding: 4px 4px 0 4px;

        .prdc-title {
          .title {
            margin-top: 0;
            padding-right: 18px;
            font-size: 12px;
            font-weight: 600;
            letter-spacing: -0.072px;
          }

          .detail {
            margin-top: 0;

            &:first-child {
              margin-top: 0;
            }

            padding-right: 23px;
            line-height: 130%;
            font-size: 12px;
            color: #333;
            ${mixin.ellipsis(1)};
          }

          .title + .detail {
            padding-right: 0;
          }
        }

        .prdc-price {
          margin-top: 1px;
          letter-spacing: -0.078px;

          .final-discount {
            margin-right: 3px;
            font-size: 13px;
          }

          .final-price {
            font-size: 13px;
          }
        }

        .area-tag {
          margin-top: 8px;
        }
      }

      .like-pick {
        top: -1px;
        right: -4px;
        height: 24px;

        svg {
          width: 16px;
          height: 16px;
        }

        &.active {
          & > div {
            width: 17px;
            height: 17px;
          }
        }
      }
    }

    .tag-ad {
      width: 24px;
      height: 16px;
      padding: 2px 3px;
      color: #fff;
      font-size: 10px;
      line-height: 130%;
    }
  }

  &.type-simple-lg {
    .img {
      padding-bottom: 133.3333%;
    }

    .emblem-area {
      height: 90px;

      svg {
        width: 52px;
        top: 12px;
        right: 11px;
      }
    }

    .rank {
      width: 32px;
      height: 32px;
      line-height: 32px;
      font-size: 17px;
      font-weight: 600;
    }

    .area-info {
      .area-click {
        padding: 8px 8px 0 8px;

        .prdc-title {
          .detail {
            ${mixin.ellipsis(1)};
            margin-top: 2px;
            padding-right: 23px;
          }

          .title + .detail {
            margin-top: 4px;
          }
        }

        .prdc-price {
          margin-top: 8px;

          .final-discount {
            margin-right: 4px;
            font-weight: 600;
          }

          .final-price {
            font-weight: 600;
          }
        }

        .area-tag {
          margin-top: 10px;
        }
      }

      .like-pick {
        top: 8px;
        right: 8px;
      }
    }
  }

  &.type-list {
    .area-img {
      flex: none;
      width: ${mixin.pxToVw('63')} !important;

      .img {
        padding-bottom: 133.3333333333333%;
      }
    }

    ${mixin.flex({ align: 'flex-start', justify: 'flex-start' })}

    .rank {
      position: relative;
      flex: none;
      width: 26px;
      padding: 4px 4px 0 2px;
      font-size: 16px;
      text-align: left;
      background-color: transparent;
      color: #000;
      font-weight: 500;
      line-height: 130%;

      em {
        font-weight: inherit;
      }
    }

    .area-info {
      flex: auto;

      .area-click {
        padding: 4px 4px 0 10px;

        .prdc-title {
          .detail {
            ${mixin.ellipsis(1)};
          }
        }

        .prdc-price {
          display: inline-block;
        }

        .area-tag {
          display: inline-block;
          margin-top: 0;
          margin-left: 6px;
          transform: translateY(-1px);
        }
      }

      .like-pick {
        top: -3px;
        right: -3px;
      }
    }
  }

  &.color-type-white {
    .rank {
      color: #fff;
    }

    .area-info {
      .title,
      .final-price,
      .tag-soldout {
        color: #fff;
      }

      .detail {
        color: #ccc !important;
      }

      .tag-soldout {
        background-color: #555;
      }

      .final-discount {
        color: #ff4600;
      }
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    &.type-simple {
      .area-info {
        .area-click {
          padding: ${mixin.pxToVw('10 4 0 4')};

          .prdc-title {
            .detail {
              padding-right: ${mixin.pxToVw('23')};
            }
          }

          .prdc-price {
            margin-top: ${mixin.pxToVw('2')};
          }

          .area-tag {
            margin-top: ${mixin.pxToVw('8')};
          }
        }

        .like-pick {
          top: ${mixin.pxToVw('2')};
          right: ${mixin.pxToVw('-4')};
        }
      }
    }

    &.type-simple-small {
      .rank {
        width: ${mixin.pxToVw('20')};
        height: ${mixin.pxToVw('20')};
        line-height: ${mixin.pxToVw('20')};
        font-size: ${mixin.pxToVw('11')};
      }

      .area-info {
        .area-click {
          padding: ${mixin.pxToVw('4 4 0 4')};

          .prdc-title {
            .title {
              padding-right: ${mixin.pxToVw('18')};
              font-size: ${mixin.pxToVw('12')};
              letter-spacing: ${mixin.pxToVw('-0.072')};
            }

            .detail {
              font-size: ${mixin.pxToVw('12')};
              padding-right: ${mixin.pxToVw('23')};
            }
          }

          .prdc-price {
            margin-top: ${mixin.pxToVw('1')};
            letter-spacing: ${mixin.pxToVw('-0.078')};

            .final-discount {
              margin-right: ${mixin.pxToVw('3')};
              font-size: ${mixin.pxToVw('13')};
            }

            .final-price {
              font-size: ${mixin.pxToVw('13')};
            }
          }

          .area-tag {
            margin-top: ${mixin.pxToVw('8')};
          }
        }

        .like-pick {
          top: ${mixin.pxToVw('-1')};
          right: ${mixin.pxToVw('-4')};
          height: ${mixin.pxToVw('24')};

          svg {
            width: ${mixin.pxToVw('16')};
            height: ${mixin.pxToVw('16')};
          }

          &.active {
            & > div {
              width: ${mixin.pxToVw('17')};
              height: ${mixin.pxToVw('17')};
            }
          }
        }
      }

      .tag-ad {
        width: ${mixin.pxToVw('24')};
        height: ${mixin.pxToVw('16')};
        padding: ${mixin.pxToVw('2 3 0 3')};
        font-size: ${mixin.pxToVw('10')};
      }
    }

    &.type-list {
      .rank {
        width: ${mixin.pxToVw('26')};
        padding: ${mixin.pxToVw('4 4 0 2')};
        font-size: ${mixin.pxToVw('16')};
      }

      .area-info {
        .area-click {
          padding: ${mixin.pxToVw('4 4 0 10')};

          .area-tag {
            margin-left: ${mixin.pxToVw('6')};
          }
        }

        .like-pick {
          top: ${mixin.pxToVw('-3')};
          right: ${mixin.pxToVw('-3')};
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    &.type-simple {
      .area-info {
        .area-click {
          padding: 14px 0 0 0;

          .prdc-title {
            .detail {
              margin-top: 2px;
              padding-right: 23px;
            }

            .title + .detail {
              margin-top: 4px;
            }
          }

          .prdc-price {
            margin-top: 8px;
          }

          .area-tag {
            margin-top: 10px;
          }
        }

        .like-pick {
          top: 14px;
          right: 0px;
        }
      }
    }

    &.type-list {
      .area-img {
        width: 72px !important;
      }

      .area-info {
        .area-click {
          padding: 4px 4px 0 16px;

          .area-tag {
            margin-left: 7px;
            transform: translateY(-2px);
          }
        }

        .like-pick {
          top: 4px;
          right: 4px;
        }
      }
    }

    /* W ONLY 엠블럼 XL : 상품 유닛이 큰 모듈에서 emblem-xl 클래스로 적용 (PC 전용) */
    &.emblem-xl {
      .area-img .emblem-area {
        height: 100px;

        svg {
          width: 72px;
          top: 16px;
          right: 16px;
        }
      }
    }
  }
`;
